import { faIdBadge } from '@fortawesome/free-regular-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const DataRequestsButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton
    label="IDVT Request"
    icon={faIdBadge}
    onClick={onClick}
    disabled={disabled}
  />
)

export default DataRequestsButton
